// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import es from 'vee-validate/dist/locale/es'
// import VueStepWizard from 'vue-step-wizard'
// import 'vue-step-wizard/dist/vue-step-wizard.css'
import * as VeeValidate from 'vee-validate'
import { Validator } from 'vee-validate'
import PeticionForm from '@/components/PeticionForm'
import Login from '@/components/Login'
import PeticionFormBuscador from '@/components/PeticionFormBuscador'
import Register from '@/components/Register'
import ListadoNeumaticos from '@/components/ListadoNeumaticos'
import PeticionNeumaticos from '@/components/PeticionNeumaticos'

Vue.use(VueFormWizard)
// Vue.use(VueStepWizard)
Validator.localize('es', es)
Vue.use(VeeValidate, {inject: true, errorBagName: 'errors', locale: 'es'})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    'baseapp': App,
    'peticionform': PeticionForm,
    'login': Login,
    'peticionformbuscador': PeticionFormBuscador,
    'register': Register,
    'listadoneumaticos': ListadoNeumaticos,
    'peticionneumaticos': PeticionNeumaticos
  }
})



// WEBPACK FOOTER //
// ./src/main.js